import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ProvedorAuth } from './auth/AuthContext';
import { ProvedorAcesso } from './auth/EstadoAcesso';
import { ProvedorRecursos } from './recursos/EstadoRecursos';
import { ProvedorTema } from './tema/TemaContext';
import './fontes.css';
import './index.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado no index.html.');

createRoot(raiz).render(
  <StrictMode>
    <ProvedorTema>
      <BrowserRouter>
        <ProvedorAuth>
          <ProvedorAcesso>
            <ProvedorRecursos>
              <App />
            </ProvedorRecursos>
          </ProvedorAcesso>
        </ProvedorAuth>
      </BrowserRouter>
    </ProvedorTema>
  </StrictMode>,
);
